import { createSelector } from 'reselect';
import { isNull } from 'lodash/fp';

const contentsSelector = state => state.pathViewer.contents;

export const completedContentCount = createSelector(
  contentsSelector,
  contents =>
    contents.filter(content => !isNull(content.progress.completedDate)).length,
);

export const completedPercentage = createSelector(
  [contentsSelector, completedContentCount],
  (content, completed) => Math.round((completed / content.length) * 100),
);
